import { getUrl, sessionExpired } from "../setEnvironment";

class RacksAPI {
  constructor() {
    this.URL = getUrl();
    this.getRacks = this.getRacks.bind(this);
    this.getAllRacks = this.getAllRacks.bind(this);
    this.getCarrierTypes = this.getCarrierTypes.bind(this);
  }

  // P01021-143: search/status/carrierType filtran por servidor sobre todo el dataset, no solo
  // la página cargada — opcionales, se omiten de la query si no se pasan.
  async getRacks(token, size, page, status, carrierType, search) {
    try {
      let url = `${this.URL}/rack/getRacks?size=${size}&page=${page}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      if (status !== undefined && status !== "") url += `&status=${encodeURIComponent(status)}`;
      if (carrierType) url += `&carrierType=${encodeURIComponent(carrierType)}`;
      const response = await fetch(
        url,
        {
          //method: "POST",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          // body: raw
        }
      ).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el backend nunca llegó a usar username para nada.
  async getAllRacks(user) {
    try {
      const response = await fetch(
        `${this.URL}/rack/getAllRacks`,
        {
          //method: "POST",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: user.token,
          },
          // body: raw
        }
      ).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async getCarrierTypes(token) {
    try {
      const response = await fetch(`${this.URL}/rack/carrierTypes`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

}

let _racksAPI = null;

const initRacksAPI = () => {
  if (!_racksAPI) {
    _racksAPI = new RacksAPI();
  }
  return _racksAPI;
};

const getRacksAPI = () => {
  return initRacksAPI();
};

export { initRacksAPI, getRacksAPI };
